import { create } from "zustand";

import { STRINGS } from "../utils/strings";

const initialState = {
  data: [],
  loading: false,
  currentPage: STRINGS.DEFAULT_PAGE,
  resLimit: STRINGS.DEFAULT_PAGINATION_LIMIT,
  resultCount: 0,
};

export const useEntityAssociationsStore = create((set) => ({
  ...initialState,
  reset: () => set(initialState),
  setCurrentPage: (page) => set({ currentPage: page }),
  setData: (data) => set({ data }),
  setLoading: (loading) => set({ loading }),
  setResultCount: (count) => set({ resultCount: count }),
}));
